export const storeNameSelector = (state) =>
    state.myAccount && state.myAccount.myAccountDetails &&
    state.myAccount.myAccountDetails.customers?.contact[0]?.storeId;